import moment from 'moment'

const common = {
	isEmptyObject (obj) {
    if (obj == null) {
      return true
    }
		return Object.keys(obj).length === 0 && obj.constructor === Object
	},

  flattenArray (arr) {
    if (!arr || !Array.isArray(arr)) {
      return
    }

    let result = []

    arr.map(item => {
      if (Array.isArray(item)) {
        result = result.concat(common.flattenArray(item))
      } else {
        result.push(item)
      }
    })
    return result
  },

  arrayToObject: (array, keyField) =>
   array.reduce((obj, item) => {
     obj[item[keyField]] = item
     return obj
   }, {}),

	calculageAge (birth, format) {
    const birthObj = moment(birth, format)
    const now = moment()
    return now.diff(birthObj, 'years')
  },

  compose: (...fns) => x => fns.reduceRight( (accu, f) => f(accu), x),

  getGender (gender) {
  	if (!gender) {
  		return
  	}
  	
    switch (Number(gender)) {
      case 0:
        return 'Female';
        break; // eslint-disable-line no-unreachable
      case 1:
        return 'Male';
        break; // eslint-disable-line no-unreachable
    }
  },
  getDateCompareToToday (daysCal) {
    // -14 or 14
    const currentTime = new Date();
    const d = currentTime.setDate(currentTime.getDate() + daysCal);
    return new Date(d).toISOString().substr(0,10);
  },
  fileRule(getExaminationData, getExaminationTypeList, getPatient) {
    // 檢查日期
    const examinationDate = getExaminationData.examination.date;
    // 個人識別號碼
    const patientId = getPatient.no;
    // 病患姓名
    const patinetName = getPatient.name;
    // 檢查報告類別
    const examinationType = getExaminationTypeList.filter(type => type.id === getExaminationData.examination.examination_typeID)[0].examination_type;
    
    //filename rule = 檢查報告類別_病患姓名_個人識別號_檢查日期
    return `${examinationType}_${patinetName}_${patientId}_${examinationDate}`;
  },
  sid() {
    return Math.random().toString(36).substring(2)
  },
  dateFormat(date) {
    // const FIRST_YEAR = 1911
    return date
      ? moment(date).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD')
  },
}

export default common